export default ["M16 1.99l-16 6 16 6-4-6z"];
//# sourceMappingURL=direction-left.js.map